import request from "./base";
const path = "/api/background";

export default {
  getScripts: function () {
    return request().get(path + "/scripts");
  },
  createJob: function(params) {
    return request().post(path + "/", params);
  },
  getById: function (id) {
    return request().get(path + "/" + id);
  },
  updateJob: function(id, params) {
    return request().put(path + "/" + id, params);
  },
  get: function () {
    return request().get(path + "/");
  },
  delete: function(params) {
    return request().delete(path + "/", {
      data: params
    });
  },
  makeTodo: function(params) {
    return request().post(path + "/make-todo", params);
  },
  getTaskById: function (id, params) {
    return request().get(`${path}/${id}/tasks`, {
      params: params
    });
  },
  addTasks: function(id, params) {
    return request().post(`${path}/${id}/tasks`, params);
  },
};
